<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
    <el-breadcrumb-item>工作汇报</el-breadcrumb-item>
    <el-breadcrumb-item>绩效查看</el-breadcrumb-item>
  </el-breadcrumb>
  <el-card>
  <el-table
    ref="multipleTable"
    :data="userList"
    border
    show-overflow-tooltip="true"
    tooltip-effect="dark"
    style="width: 100%"
    >
    <el-table-column
      label="姓名"
      width="120"
      :show-overflow-tooltip="true"
      prop="name">
      
    </el-table-column>
  
    <el-table-column
      label="用户名"
      width="120"
      :show-overflow-tooltip="true"
      prop="username">
    </el-table-column>

    <el-table-column
      label="剩余时间(分钟)"
      width="150"
      :show-overflow-tooltip="true"
      prop="token">
    </el-table-column>
    <el-table-column
      label="登录时间"
      width="150"
      :show-overflow-tooltip="true"
      prop="mobiles">
    </el-table-column>

    <el-table-column
      label="滞留"
      width="150"
      :show-overflow-tooltip="true"
      prop="email">
    </el-table-column>
  </el-table>

  
  </el-card>
  
  
  
  
  </div>
  </template>
  
  <script>
  export default {
  created(){
   this.getList()
  },
  data(){
    return{
        userList:[],
        total:null,
        currentPage4: 1,
    }
  },methods:{
    getList(){
        this.axios.get("/user/"+"getUserLoginList")
        .then(resp=>{

            this.userList=resp.data
            resp.data.forEach(element => {
              this.getDifferenceInMinutes(element.mobiles);
            });
      
           
        })
    },
     getDifferenceInMinutes(targetDateString) {
    // 将目标日期字符串转换为 Date 对象
    const targetDate = new Date(targetDateString).getTime();
    const currentDate = new Date().getTime();

    // 计算时间差（毫秒）
    const differenceInMillis = currentDate-targetDate;
    console.log("differenceInMillis",differenceInMillis)
    const differenceInMinutes = Math.floor(differenceInMillis / (1000 * 60));
console.log('differenceInMinutes',differenceInMinutes)
return differenceInMinutes
}

  }
  
  }
  </script>
  
  <style>
  
  </style>


// WEBPACK FOOTER //
// src/components/work/administrative/LoginUserList.vue